import { render, staticRenderFns } from "./ListItemPlace.vue?vue&type=template&id=240644fa&"
import script from "./ListItemPlace.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ListItemPlace.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('240644fa')) {
      api.createRecord('240644fa', component.options)
    } else {
      api.reload('240644fa', component.options)
    }
    module.hot.accept("./ListItemPlace.vue?vue&type=template&id=240644fa&", function () {
      api.rerender('240644fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ListItemPlace/ListItemPlace.vue"
export default component.exports